import { endpoint } from "views/pages/manage/common/constant"
import { dropdownMapping } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod"

// import { dropdownMapping } from "views/pages/manage/unAssigned/studentCharges/common"

export const newRow={
    taxType:'',
    taxCodeType:'',
    codeId:'',
    taxCodePercent:'',
    effectiveDate:''
}
const taxTypeMappingDropdown =[
    {label:'Receipt', value:'Receipt'},
    {label:'Refund', value:'Refund'},
]

const taxCodeTypeDropdown =[
    {label:'GST', value:'GST'},
    {label:'Service Tax', value:'Service Tax'},
    {label:'VAT', value:'VAT'},
]

export const getDropdowns= async()=>{
    const dropdown = await Promise.all([
      dropdownMapping(
        endpoint.taxCodeId.getAll,
        "taxCodeIdKey",
        "taxCodeIdKey",
        'id'
      ),])
      return{
        codeId: dropdown[0],
        taxType: taxTypeMappingDropdown,
        taxCodeType:taxCodeTypeDropdown,
      }
}
